import { useState, useEffect } from "react";
import locationList from "../Data/US_CostLiving_LocationList.json";
import { statistics } from "../Data/statisticSource";

class Locations {
  constructor(locations) {
    this.locations = locations;
    this.locationDict = {};
    this.locationMaximums = {};
    this.locationMinimums = {};
    this.locations.forEach((location) => {
      this.locationDict[location.id] = location;
    });

    for (const statKey in statistics) {
      const statValues = this.locations
        .map((loc) => loc[statKey])
        .filter((val) => val !== null && val !== undefined);
      if (statValues.length > 0) {
        this.locationMaximums[statKey] = Math.max(...statValues);
        this.locationMinimums[statKey] = Math.min(...statValues);
      } else {
        this.locationMaximums[statKey] = null;
        this.locationMinimums[statKey] = null;
      }
    }
  }

  getNormalizedLocationStat(location, statKey) {
    if (
      !this.locationMaximums.hasOwnProperty(statKey) ||
      !this.locationMinimums.hasOwnProperty(statKey)
    ) {
      throw new Error(`Statistic key ${statKey} not found in location stats.`);
    }

    const maxVal = this.locationMaximums[statKey];
    const minVal = this.locationMinimums[statKey];
    const locVal = location[statKey];

    if (locVal === null || locVal === undefined || maxVal === minVal) {
      throw new Error(`Can't Normalize`);
    }

    // Normalize to a 0-1 scale
    return (locVal - minVal) / (maxVal - minVal);
  }

  getLocationList() {
    return this.locations;
  }

  getLocation(id) {
    return this.locationDict[id];
  }
}

const useLocationList = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const locations = new Locations(locationList);
    setData(locations);
  }, []);

  return [data, setData];
};

export default useLocationList;
